import type { Ticket, TicketAuthor } from './types.js';

/** What Implement offers, from the ticket's authors: who still needs the operator's trust */
export function authorsToTrust(t: Ticket): { known: boolean; untrusted: TicketAuthor[]; logins: string[] } {
  if (!t.authors) return { known: false, untrusted: [], logins: [] };
  const untrusted = t.authors.filter((a) => !a.trusted);
  return { known: true, untrusted, logins: untrusted.filter((a) => !a.bot).map((a) => a.login) };
}
